import React from "react";
import { Route, Routes } from "react-router-dom";
import { Auth } from "../components/Auth/Auth";
import PrivacyPolicy from "../components/PrivacyPolicy/PrivacyPolicy";
import TermsAndConditions from "../components/TermsAndConditions/TermsAndConditions";
import ChangePassword from "../pages/ChangePassword/ChangePassword";
import EmailVerification from "../pages/EmailVerification/EmailVerification";
import IntakeForm from "../pages/IntakeForm/IntakeForm";
import Login from "../pages/Login/Login";
import NewPassword from "../pages/NewPassword/NewPassword";
import RecoverPassword from "../pages/RecoverPassword/RecoverPassword";
import Register from "../pages/Register/Register";
import Report from "../pages/Report/Report";
import Dashboard from "../pages/User/Dashboard";
import ProviderDashboard from "../pages/Provider/Dashboard";
import IntakeData from "../pages/Provider/IntakeData/IntakeData";
import PatientDetails from "../pages/Provider/PatientDetails/PatientDetails";
import Catalogs from "../pages/Provider/Products/Catalogs/Catalog";
import CatalogCreate from "../pages/Provider/Products/Catalogs/CatalogCreate";
import ListPlans from "../pages/Provider/Paypal/Plan/ListPlans/ListPlans";
import Product_Details from "../pages/ProductDetails/ProductDetails";
// import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import Checkout from "../pages/Checkout/Checkout";
import Confirmation from "../pages/Confirmation/Confirmation";
import CatalogEdit from "../pages/Provider/Products/Catalogs/CatalogEdit";
import PatientOrder from "../pages/Provider/PatientOrder/PatientOrder";
// import { useSelector } from 'react-redux'
import MyOrder from "../pages/Provider/MyOrder/MyOrder";
import OrderView from "../pages/Provider/PatientOrder/OrderView";
import MyOrderView from "../pages/Provider/MyOrder/MyOrderView";
import NotFound from "../pages/NotFoundPage/NotFound";
import Admins from "../pages/Provider/Admins/admins";
import AppointmentIndexPage from "../pages/appointment-scheduling";
import AvailableSlots from "../pages/appointment-scheduling/availableSlots";
import BookingPage from "../pages/appointment-scheduling/booking-page";
import HomePage from "../pages/HomePage/homePage";
import Index from "../pages/symptomsTracker";
import UserAssessments from "../pages/symptomsTracker/UserAssessments";
import ConfirmBooking from "../pages/appointment-scheduling/confirmBooking";
import ScheduledMeetings from "../pages/Provider/ScheduledMeetings/ScheduledMeetings";
import TestIndexPage from "../pages/LabTestsPages";
import AddNewTest from "../pages/LabTestsPages/addNewTest";
import TestDetailPage from "../pages/LabTestsPages/testDetailPage";
import EditTest from "../pages/LabTestsPages/editTestPage";
import PatientLabTests from "../pages/Provider/TestsPages/PatientLabTests";
import PatientTestDetail from "../pages/Provider/TestsPages/PatientTestDetail";
import OrderKit from "../pages/Provider/orderKit";
import KitCart from "../pages/Provider/orderKit/kitCart";
import KitCheckout from "../pages/Provider/orderKit/kitCheckout";
import KitOrders from "../pages/Provider/orderKit/kitOrders";
import UserKitOrders from "../pages/UserKitOrders/userKitOrders";
import UserKitCheckout from "../pages/UserKitOrders/userKitCheckout";
import AddUserPassword from "../pages/addUserPassword/addUserPassword";
import PatientReport from "../pages/Provider/PatientReport/PatientReport";
export default function Routers() {
  // const paypalClientKey = process.env.REACT_APP_PAYPAL_CLIENT_KEY;
  //   const cartProduct = useSelector((state) => state.cart);
  return (
    <>
      <Routes>
        <Route path="*" element={<NotFound></NotFound>}></Route>
        <Route path="/" element={<Login></Login>}></Route>
        <Route path="/register" element={<Register></Register>}></Route>
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy></PrivacyPolicy>}
        ></Route>
        <Route path="/consent" element={<TermsAndConditions />}></Route>
        <Route path="/recover-password" element={<RecoverPassword />}></Route>
        <Route
          path="/new-password/:token"
          element={<NewPassword></NewPassword>}
        ></Route>
        <Route
          path="/verify/account/:token"
          element={<EmailVerification></EmailVerification>}
        ></Route>
        <Route path="/add-user-password/:token" element={<AddUserPassword></AddUserPassword>}></Route>

        <Route path="/app" element={<Auth />}>
          <Route path="home" element={<HomePage></HomePage>}></Route>
          <Route path="symptoms-tracker" element={<Index></Index>}></Route>
          <Route path="lab-results" element={<Dashboard></Dashboard>}></Route>
          <Route path="tracker-history" element={<UserAssessments></UserAssessments>}></Route>
          <Route path="user-kit-orders" element={<UserKitOrders></UserKitOrders>}></Route>
          <Route path="user-kit-checkout/:orderId" element={<UserKitCheckout></UserKitCheckout>}></Route>
          <Route
            path="medical-history"
            element={<IntakeForm></IntakeForm>}
          ></Route>
          <Route path="report/:kitId" element={<Report></Report>}></Route>
          <Route
            path="change-password"
            element={<ChangePassword></ChangePassword>}
          ></Route>
          <Route path="my-orders" element={<MyOrder></MyOrder>}></Route>
          <Route path="appointment-scheduling" element={<AppointmentIndexPage></AppointmentIndexPage>}></Route>
        <Route path="available-slots" element={<AvailableSlots></AvailableSlots>}></Route>
        <Route path="booking-page" element={<BookingPage></BookingPage>}></Route>
        <Route path="confirm-booking" element={<ConfirmBooking></ConfirmBooking>}></Route>
        <Route path="lab-tests" element={<TestIndexPage></TestIndexPage>}></Route>
        <Route path="add-new-test" element={<AddNewTest></AddNewTest>}></Route>
        <Route path="edit-test/:id" element={<EditTest></EditTest>}></Route>
        <Route path="test-details/:id" element={<TestDetailPage></TestDetailPage>}></Route>
          {/* Provider Routes */}
          <Route path="patient-report/:kitId" element={<PatientReport></PatientReport>}></Route>
          <Route
            path="dashboard"
            element={<ProviderDashboard></ProviderDashboard>}
          ></Route>
          <Route
            path="patient-profiles"
            element={<IntakeData></IntakeData>}
          ></Route>
          <Route
            path="patient-details/:id"
            element={<PatientDetails></PatientDetails>}
          ></Route>
          <Route path="catalogs" element={<Catalogs></Catalogs>}></Route>
          <Route
            path="catalogs/add"
            element={<CatalogCreate></CatalogCreate>}
          ></Route>
          <Route
            path="catelogs/edit"
            element={<CatalogEdit></CatalogEdit>}
          ></Route>
          <Route path="list-plans/:productId" element={<ListPlans />}></Route>
          {/* <Route path="product-details" element={<Product_Details />}></Route> */}
          <Route path="checkout" element={<Checkout />}></Route>
          <Route
            path="confirmation"
            element={<Confirmation></Confirmation>}
          ></Route>
          <Route
            path="patient-order"
            element={<PatientOrder></PatientOrder>}
          ></Route>
          <Route
            path="view-order/:id"
            element={<OrderView></OrderView>}
          ></Route>
          <Route
            path="view-my-order/:id"
            element={<MyOrderView></MyOrderView>}
          ></Route>
          <Route path="admins-list" element={<Admins></Admins>}></Route>
          <Route path="scheduled-meetings" element={<ScheduledMeetings></ScheduledMeetings>}></Route>
          <Route path="patient-lab-tests" element={<PatientLabTests></PatientLabTests>}></Route>
          <Route path="patient-test-details/:id" element={<PatientTestDetail></PatientTestDetail>}></Route>
          <Route path="kit-orders" element={<KitOrders></KitOrders>}></Route>
          <Route path="kit-cart" element={<KitCart></KitCart>}></Route>
          <Route path="order-kit" element={<OrderKit></OrderKit>}></Route>
          <Route path="kit-checkout" element={<KitCheckout></KitCheckout>}></Route>
        </Route>
      </Routes>
    </>
  );
}
